import type { RoutesPagePreset } from './routesPageFilterPersistence';

export type RoutesPagePresetDefinition = {
  key: RoutesPagePreset;
  label: string;
  countKey?:
    | 'all'
    | 'awaitLoading'
    | 'inTransit'
    | 'awaitPayment'
    | 'completed'
    | 'issues'
    | 'readyForCompletion';
  requiresShowCompleted?: boolean;
};

export const ROUTES_PAGE_PRESETS: RoutesPagePresetDefinition[] = [
  { key: 'all', label: 'Все', countKey: 'all' },
  { key: 'await_loading', label: 'Ожидают погрузки', countKey: 'awaitLoading' },
  { key: 'in_transit', label: 'В пути', countKey: 'inTransit' },
  { key: 'await_payment', label: 'Ожидают оплаты', countKey: 'awaitPayment' },
  { key: 'completed', label: 'Завершены', countKey: 'completed', requiresShowCompleted: true },
  { key: 'issues', label: 'Проблемы', countKey: 'issues' },
  { key: 'ready_for_completion', label: 'Готов к завершению', countKey: 'readyForCompletion' },
];

export const ROUTES_PAGE_PAYMENT_FILTER_OPTIONS: Array<{
  value: 'all' | 'ok' | 'partial' | 'open' | 'overdue' | 'await_payment';
  label: string;
}> = [
  { value: 'all', label: 'Все' },
  { value: 'ok', label: 'Оплачено' },
  { value: 'partial', label: 'Частично оплачено' },
  { value: 'open', label: 'Не оплачено' },
  { value: 'overdue', label: 'Просрочено' },
  { value: 'await_payment', label: 'Ожидают оплаты' },
];
